export const DEFAULT_RANK = 1;

export const DEFAULT_AMOUNT_OF_RANKS = 3; // [0, 1, 2]
